/**
 * Created by:  phpStorm
 * Developer:   Pashkov Alexander
 * Upwork:      https://www.upwork.com/fl/alexanderpashkov
 * Email:       viplikensk@gmail.com
 * Site:        https://viplike.ru
 * Skype:       viplike_nsk
 * Date:        15.05.2020
 * Time:        16:04
 *
 * On business proposals, please write to the above contacts
 */

/**
 * custom photo swipe
 */
class CustomPhotoSwipe {

  /**
   * constructor
   * @param itemSelector
   */
  constructor(itemSelector) {
    this.itemSelector = itemSelector;

    // assign common handlers
    this.assignCommonHandlers();
  }

  /**
   * assign common handlers
   */
  assignCommonHandlers() {
    // select all gallery elements
    const galleryElements = document.querySelectorAll(this.itemSelector);
    const l = galleryElements.length;
    for (let i = 0; i < l; i++) {
      // check that handlers are set
      if (galleryElements[i].dataset.handlersAreSet === undefined) {
        galleryElements[i].dataset.pswpUid = i + 1;
        galleryElements[i].addEventListener('click', this.onThumbnailsClick.bind(this));

        // set handlers
        galleryElements[i].dataset.handlersAreSet = true;
      } else {
        console.log('continue');
      }
    }
  }

  /**
   * parse thumbnail elements
   * @param galleryId
   * @returns {[]}
   */
  parseThumbnailElements(galleryId) {
    // get gallery items
    const galleryItems = document.querySelectorAll('.photo-swipe-item[data-gallery-id="' + galleryId + '"]');
    const galleryItemsLength = galleryItems.length;
    const items = [];

    // looping through
    for (let i = 0; i < galleryItemsLength; i++) {
      const galleryItem = galleryItems[i];
      let size = galleryItem.dataset.size.split('x');

      // create slide object
      const item = {
        src: galleryItem.getAttribute('href'),
        w: parseInt(size[0], 10),
        h: parseInt(size[1], 10),
      };

      // save link to the element for getThumbBoundsFn
      item.el = galleryItem;

      // img tag
      const imageItem = galleryItem.querySelector('img');
      if (imageItem) {
        // thumbnail url
        item.msrc = imageItem.getAttribute('src');

        // caption
        item.title = imageItem.getAttribute('alt');

        // medium size
        let mediumSrc = imageItem.dataset.srcMed;
        if (mediumSrc) {
          size = galleryItem.dataset.sizeMed.split('x');
          // "medium-sized" image
          item.m = {
            src: mediumSrc,
            w: parseInt(size[0], 10),
            h: parseInt(size[1], 10)
          };
        }
      }

      // original image
      item.o = {
        src: item.src,
        w: item.w,
        h: item.h
      };

      // push image to the list
      items.push(item);
    }

    // output
    return items;
  }

  /**
   * on thumbnails click
   * @param e
   * @returns {boolean}
   */
  onThumbnailsClick(e) {
    e = e || window.event;
    e.preventDefault ? e.preventDefault() : e.returnValue = false;

    const eTarget = e.target || e.srcElement;
    const clickedListItem = eTarget.closest('a');

    if (!clickedListItem) {
      return false;
    }

    // get gallery id
    const galleryId = clickedListItem.dataset.galleryId;

    // get all gallery items
    const galleryItems = document.querySelectorAll('.photo-swipe-item[data-gallery-id="' + galleryId + '"]');
    const numChildNodes = galleryItems.length;
    let nodeIndex = 0;
    let index;

    for (let i = 0; i < numChildNodes; i++) {
      if (galleryItems[i].nodeType !== 1) {
        continue;
      }

      if (galleryItems[i] === clickedListItem) {
        index = nodeIndex;
        break;
      }
      nodeIndex++;
    }

    if (index >= 0) {
      this.openPhotoSwipe(index, galleryId, true);
    }

    return false;
  }

  /**
   * open photo swipe
   * @param index
   * @param galleryId
   * @param disableAnimation
   * @param fromURL
   */
  openPhotoSwipe(index, galleryId, disableAnimation, fromURL) {
    const pswpElement = document.querySelectorAll('.pswp')[0];
    const items = this.parseThumbnailElements(galleryId);

    // define options (if needed)
    const options = {
      galleryUID: galleryId,

      // for images with different ratio of thumbnail and original image
      showHideOpacity: true,

      // for images with equal ratio of thumbnail and original image
      getThumbBoundsFn: function (index) {
        // See Options->getThumbBoundsFn section of docs for more info
        const thumbnail = items[index].el.children[0];
        const pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
        const rect = thumbnail.getBoundingClientRect();
        return {x: rect.left, y: rect.top + pageYScroll, w: rect.width};
      },
      addCaptionHTMLFn: function (item, captionEl, isFake) {
        if (!item.title) {
          captionEl.children[0].innerText = '';
          return false;
        }
        captionEl.children[0].innerHTML = item.title;
        return true;
      },
    };

    if (fromURL) {
      if (options.galleryPIDs) {
        // parse real index when custom PIDs are used
        // https://photoswipe.com/documentation/faq.html#custom-pid-in-url
        const itemsLength = items.length;
        for (let j = 0; j < itemsLength; j++) {
          if (items[j].pid === index) {
            options.index = j;
            break;
          }
        }
      } else {
        options.index = parseInt(index, 10) - 1;
      }
    } else {
      options.index = parseInt(index, 10);
    }

    // exit if index not found
    if (isNaN(options.index)) {
      return;
    }

    const radios = document.getElementsByName('gallery-style');
    const radiosLength = radios.length;
    for (let i = 0, length = radiosLength; i < length; i++) {
      if (radios[i].checked) {
        if (radios[i].id === 'radio-all-controls') {

        } else if (radios[i].id === 'radio-minimal-black') {
          options.mainClass = 'pswp--minimal--dark';
          options.barsSize = {top: 0, bottom: 0};
          options.captionEl = false;
          options.fullscreenEl = false;
          options.shareEl = false;
          options.bgOpacity = 0.85;
          options.tapToClose = true;
          options.tapToToggleControls = false;
        }
        break;
      }
    }

    if (disableAnimation) {
      options.showAnimationDuration = 0;
    }

    // Pass data to PhotoSwipe and initialize it
    const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

    // see: http://photoswipe.com/documentation/responsive-images.html
    let useLargeImages, firstResize, imageSrcWillChange;
    gallery.listen('beforeResize', () => {
      let dpiRatio = window.devicePixelRatio ? window.devicePixelRatio : 1;
      dpiRatio = Math.min(dpiRatio, 2.5);
      const realViewportWidth = gallery.viewportSize.x * dpiRatio;
      if (realViewportWidth >= 1200 || (!gallery.likelyTouchDevice && realViewportWidth > 800) || screen.width > 1200) {
        if (!useLargeImages) {
          useLargeImages = true;
          imageSrcWillChange = true;
        }
      } else {
        if (useLargeImages) {
          useLargeImages = false;
          imageSrcWillChange = true;
        }
      }
      if (imageSrcWillChange && !firstResize) {
        gallery.invalidateCurrItems();
      }
      if (firstResize) {
        firstResize = false;
      }
      imageSrcWillChange = false;
    });
    gallery.listen('gettingData', (index, item) => {
      if (useLargeImages) {
        item.src = item.o.src;
        item.w = item.o.w;
        item.h = item.o.h;
      } else {
        item.src = item.m.src;
        item.w = item.m.w;
        item.h = item.m.h;
      }
    });
    gallery.init();
  }

}

// register a gallery
const customPhotoSwipe = new CustomPhotoSwipe('.photo-swipe-item');